module.exports = __webpack_public_path__ + "static/media/48363862_2308809189194259_7494159371023155200_o-thumb.76622505.jpg";